import { render } from "./SlidePaginator.vue?vue&type=template&id=6db29ee5&scoped=true"
import script from "./SlidePaginator.vue?vue&type=script&lang=js"
export * from "./SlidePaginator.vue?vue&type=script&lang=js"

import "./SlidePaginator.vue?vue&type=style&index=0&id=6db29ee5&lang=css"
import "./SlidePaginator.vue?vue&type=style&index=1&id=6db29ee5&scoped=true&lang=scss"

import exportComponent from "/Users/nigomatulin/projects/WOPA/tverstroyka/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db29ee5"]])

export default __exports__